import React from "react";

import { BlankStory } from "../story-templates/blank.js";
import { PhotoStory } from "../story-templates/photo.js";
import { LiveBlogStory } from "../story-templates/live-blog.js";
import { VideoStory } from "../story-templates/video.js";
import { InfiniteStoryBase } from "@quintype/components";

export function StoryPageContent({story, relatedStories, index, preview = false }, config) {
  switch(story['story-template']) {
    case 'live-blog':
      return <LiveBlogStory story={story} config={config} preview={preview} />;
    case 'video':
      return <VideoStory story={story} config={config} preview={preview} />;
    case 'photo':
      return <PhotoStory story={story} config={config} preview={preview} />;
    default:
      return <BlankStory story={story} config={config} preview={preview} />;
  }
}

const FIELDS = "id,headline,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,author-name,author-id,sections,story-template,cards,tags,authors";
function storyPageLoadItems(pageNumber) {
  return fetch(`/api/v1/collections/curated-story-list?item-type=story&item-fields=${FIELDS}&limit=5&offset=${5 * pageNumber}`)
          .then(response => {
            return response.json();
          })
          .then(response => {
            return response.items.map(item => ({ story: item.story }));
          })
          .catch(err => {
            console.error('Error in retrieving infinite scroll stories :', err);
            return [];
          });
}

export class StoryPage extends React.Component {
  
  doAnalytics(story) {
    const { registerPageView } = require("@quintype/framework/client/analytics");
    registerPageView({type: "story-page", story: story}, `/${story.slug}`);
  }

  render() {
    if(this.props.preview){
      return StoryPageContent(this.props.data, this.props.config);
    }
    return <InfiniteStoryBase {...this.props}
              render={(storyProps) => StoryPageContent(storyProps, this.props.config)}
              loadItems={storyPageLoadItems}
              onItemFocus={(item) => console.log(`Story In View: ${item.story.headline}`)}
              onInitialItemFocus={(item) => this.doAnalytics(item.story)} />
  }
}
